/**
 * Created by lari on 03/05/2017.
 */
/* either pass list of clients (patients) to dispay or load clients/patients depending on mode */

// TODO: figure out what this thing is actually good for? Might be obsolete, doesn't work as expected?

(function () {
  'use strict';
  angular.module('vcdrug')
    .component('numberofactivedrugs', {
      restrict: 'E',
      bindings: {
        patientid: '@?'
      },
      template: `
        <span ng-bind="vm.activedrugs"></span>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', 'Drug', 'vertxEventBusService',
        function ($log, Rlog, Drug, vertxEventBusService) {
          let vm = this;


          vm.$onInit = function () {
            Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
              vm.patdrugs = drugs[0];
              calculateActivedrugs(vm.patdrugs);
            });
          };

          function calculateActivedrugs(drugs) {
            vm.activedrugs = 0;
            for (let i = 0; i < drugs.drugs.length; i++) {
              if (drugs.drugs[i] && drugs.drugs[i].active === true && drugs.drugs[i].foreign === false) {
                vm.activedrugs++;
              }
            }
          }

          const patdrugsUpdateHandler = function (message) {
            // $log.debug('debug: Client update received: ', message);
            let messages = message.split(':');
            if (angular.isDefined(vm.patdrugs) && vm.patdrugs._id === messages[0]) {
              vm.patdrugs.$refresh().$then(function (drugs) {
                calculateActivedrugs(drugs);
                $log.debug('refreshed patdrugs active nr: ', vm.activedrugs);
              }, function (error) {
                $log.debug('refreshing patdrugs active number failed: ', error, vm.activedrugs);
              });
            }
          };

          vertxEventBusService.on('patdrugs.update', {}, patdrugsUpdateHandler());

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('patdrugs.update', {}, patdrugsUpdateHandler);
          };

        }] // controller
    }); // component

  // klammerfriedhof
}());
